module.exports = __webpack_public_path__ + "img/full5-min.760ac549.png";